import { CombinedState, createStore, Reducer } from 'redux';

import { GlobalState, initialState } from './initialState';
import rootReducer from './rootReducer';

const createTestStore = (): ReturnType<typeof createStore> =>
  createStore(rootReducer as Reducer<CombinedState<GlobalState>>, initialState);

export { createTestStore };
